import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FileUploadInputComponent} from './file-upload-input.component';
import {DndModule} from 'ngx-drag-drop';
import {TranslocoModule} from '@ngneat/transloco';
import {ButtonModule} from '@blocks/button/button.module';
import {FormsModule} from '@angular/forms';
import {FileSizeModule} from '@shared/pipes/file-size/file-size.module';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCloudUpload, faTrash} from '@fortawesome/pro-light-svg-icons';
import {IconLibraryService, IconsModule, plBuilderAttachmentVertical} from '@paperlessio/sdk/icons';
import {IneligibilityOverlayModule} from '@blocks/input/ineligibility-overlay/ineligibility-overlay.module';
import {FilePickerModule} from '@shared/controls/file-picker/file-picker.module';
import {SubmissionGizmoModule} from '@shared/submission-gizmo/submission-gizmo.module';
import {faShieldCheck} from '@fortawesome/pro-regular-svg-icons';
import {RequiredIndicatorComponent} from '@shared/controls/required-indicator/required-indicator.component';
import {FontSizeModule} from '@shared/directives/font-size/font-size.module';
import {LoadingSpinnerModule} from '@paperlessio/sdk/components/loading-spinner';

@NgModule({
  declarations: [
    FileUploadInputComponent
  ],
  imports: [
    CommonModule,
    DndModule,
    IconsModule,
    TranslocoModule,
    ButtonModule,
    FilePickerModule,
    FormsModule,
    FileSizeModule,
    LoadingSpinnerModule,
    FontAwesomeModule,
    IneligibilityOverlayModule,
    SubmissionGizmoModule,
    RequiredIndicatorComponent,
    FontSizeModule,
  ],
  exports: [
    FileUploadInputComponent
  ]
})
export class FileUploadInputModule {
  constructor(library: IconLibraryService, faLibrary: FaIconLibrary,) {
    library.addIcons(plBuilderAttachmentVertical);
    faLibrary.addIcons(faCloudUpload, faTrash, faShieldCheck);
  }
}
